var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSsSouthSudan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_23256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 31.5H0V45H60V31.5Z",
    fill: "#078930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 13.5H0V31.5H60V13.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V13.5H60V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 15.75H0V29.25H60V15.75Z",
    fill: "#DA121A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0L21.0281 22.5L60 45V0Z",
    fill: "#0F47AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1846 18.2625L54.2158 22.5L41.1846 26.7281L49.2283 15.6562V29.3438L41.1846 18.2625Z",
    fill: "#FCDD09"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_23256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsSouthSudan);
export default __webpack_public_path__ + "static/media/ss South Sudan.80d3ec26d8dec9549225657a2d47379f.svg";
export { ForwardRef as ReactComponent };